export const EDITOR_MANAGING_SUBDIVISION_OPTIONS = [
  "code",
  "name",
  "status",
  "IncludedInDivisionName",
  "createdAt",
];
